import { Typography } from '@mui/material'
import Grid from '@mui/material/Unstable_Grid2'
import { useSelector } from 'react-redux'
import { IRootState } from '../../../../../../redux/types'

function UserNotifications() {
  const { user: authUser } = useSelector((state: IRootState) => state.auth)
  const { userProfileSelected } = useSelector((state: IRootState) => state.user)

  return (
    <>
      {authUser !== null && userProfileSelected !== null && (
        <Grid xs={12}>
          <Grid container justifyContent="space-between" alignItems="flex-start">
            <Grid xs={10}>
              <Typography>Avisame todas las actualizaciones de {import.meta.env.VITE_NAME}</Typography>
            </Grid>
            <Grid xs={2}>{/* <CustomSwitchComponent /> */}</Grid>
          </Grid>

          <Grid container justifyContent="space-between" alignItems="flex-start">
            <Grid xs={10}>
              <Typography>Deseo recibir correos electrónicos cuando existan cambios en {import.meta.env.VITE_NAME}</Typography>
            </Grid>
            <Grid xs={2}>{/* <CustomSwitchComponent /> */}</Grid>
          </Grid>

          <Typography variant="body2" color="textSecondary">
            {import.meta.env.VITE_NAME} | Website
          </Typography>
          <Grid container justifyContent="space-between" alignItems="flex-start">
            <Grid xs={10}>
              <Typography>Habilitar alertas de Ofertas</Typography>
            </Grid>
            <Grid xs={2}>{/* <CustomSwitchComponent /> */}</Grid>
          </Grid>

          <Typography variant="body2" color="textSecondary">
            {import.meta.env.VITE_NAME} | Website
          </Typography>
          <Grid container justifyContent="space-between" alignItems="flex-start">
            <Grid xs={10}>
              <Typography>Habilitar alertas de Academia</Typography>
            </Grid>
            <Grid xs={2}>{/* <CustomSwitchComponent /> */}</Grid>
          </Grid>

          <Typography variant="body2" color="textSecondary">
            {import.meta.env.VITE_NAME} | Admin
          </Typography>
          <Grid container justifyContent="space-between" alignItems="flex-start">
            <Grid xs={10}>
              <Typography>Avisame cuando creen un nuevo recurso</Typography>
            </Grid>
            <Grid xs={2}>{/* <CustomSwitchComponent /> */}</Grid>
          </Grid>

          <Typography variant="body2" color="textSecondary">
            {import.meta.env.VITE_NAME} | Admin
          </Typography>
          <Grid container justifyContent="space-between" alignItems="flex-start">
            <Grid xs={10}>
              <Typography>Avisame cuando editen un recurso</Typography>
            </Grid>
            <Grid xs={2}>{/* <CustomSwitchComponent /> */}</Grid>
          </Grid>
        </Grid>
      )}
    </>
  )
}

export default UserNotifications
